/* Tonic Home V2 footer: on phones each link column folds behind its heading. */
class ThFooter extends HTMLElement {
  connectedCallback() {
    this.phone = matchMedia('(max-width: 749px)');
    this.cols = [...this.querySelectorAll('.th-fcol')];
    this.cols.forEach((col) => col.querySelector('.th-fcol__btn').addEventListener('click', () => {
      if (!this.phone.matches) return;
      this.setOpen(col, !col.classList.contains('is-open'));
    }));
    // On larger screens the columns are always open, so the headings are not tab stops.
    this.sync = () => this.cols.forEach((col) => {
      this.setOpen(col, !this.phone.matches);
      col.querySelector('.th-fcol__btn').tabIndex = this.phone.matches ? 0 : -1;
    });
    this.phone.addEventListener('change', this.sync);
    this.sync();
  }

  setOpen(col, open) {
    col.classList.toggle('is-open', open);
    col.querySelector('.th-fcol__btn').setAttribute('aria-expanded', open);
  }
}

if (!customElements.get('th-footer')) customElements.define('th-footer', ThFooter);
